import React, { useState, useEffect } from "react";
import "./Result.css"; // Import your external CSS file

function ClickCounter(props) {
  const [bar1Counter, setBar1Counter] = useState(props.countone);
  const [bar2Counter, setBar2Counter] = useState(props.counttwo);
    const [totalCount, setTotalCount] = useState(props.countone + props.counttwo);
    const [currselect,setselect] = useState(0);
    const inx = props.inx;

    

  const handleOption1Click = () => {
    setBar1Counter(bar1Counter + 1);
    const newchoice = props.currchoice;
    newchoice[inx] = 0;
    props.setchoice([...newchoice]);
  
 
    
    
  };

  const handleOption2Click = () => {
    setBar2Counter(bar2Counter + 1);
    handleOptionClick();
    const newchoice = props.currchoice;
    newchoice[inx] = 1;
    props.setchoice([...newchoice]);
    
    
  };

  const handleOptionClick = () => {
    const bar1Width = (300 * bar1Counter) / (bar1Counter + bar2Counter);
    const bar2Width = (300 * bar2Counter) / (bar1Counter + bar2Counter);

    document.getElementById("bar1").style.width = `${bar1Width}px`;
    document.getElementById("bar2").style.width = `${bar2Width}px`;
  };
  useEffect(() => {
    handleOptionClick();
  }, [bar1Counter, bar2Counter, handleOptionClick]);

  return (
    <>
      <div id="main">
        <div>
          {props.description}
        </div>
        
        <div class="row">
          <button class="options" id="option1" onClick={handleOption1Click}>
            {props.optionOne}
          </button>

          <button class="options" id="option2" onClick={handleOption2Click}>
            {props.optiontwo}
          </button>
        </div>

        <div class="row">
          <p class="perc" id="bar1perc">
            {bar1Counter == 0 && bar2Counter == 0
              ? 50
              : ((bar1Counter / (bar1Counter + bar2Counter)) * 100).toFixed(0)}
            %
          </p>

          <div id="Cont">
            <div class="bar" id="bar1"></div>

            <div class="bar" id="bar2"></div>
          </div>

          <p class="perc" id="bar2perc">
            {bar1Counter == 0 && bar2Counter == 0
              ? 50
              : ((bar2Counter / (bar1Counter + bar2Counter)) * 100).toFixed(0)}
            %
          </p>
        </div>
      </div>
    </>
  );
}

export default ClickCounter;
